import GradientBorderRadius from "@/ui/gradient-border-radius";
import PrivacyPolicyHeader from "./privacy-policy-header";

const PrivacyPolicy = () => {
  return (
    <GradientBorderRadius
      background="section-gradient"
      overflow
      className="flex-1 flex w-full"
    >
      <div className="flex-1 flex flex-col w-full gap-[0.625rem] pt-[0.625rem]">
        <PrivacyPolicyHeader />
        <div className="h-full w-full px-[0.625rem] overflow-auto custom-scrollbar">
          <p className="text-xs">
            This privacy notice for MAITRIX LTD (“MAITRIX LTD”) describes how
            and why we might collect, store, use, and/or process your
            information when you use our services, such as when you: <br />
            <br /> Visit our website at https://www.arkaine.io/, or any website
            of ours that links to this privacy notice. Engage with us in other
            related ways, including any marketing activities.
            <br />
            <br />
            Questions or concerns? Reading this Privacy Policy or privacy notice
            will help you understand your privacy rights and choices.
            <br />
            <br />
            By accessing, connecting, clicking on, using, or engaging in the
            Services, you indicate and confirm that you have consented and
            agreed to the terms of this Privacy Policy. We will not use your
            Personal Information for any other purpose that has not covered in
            this Privacy Policy or the Terms without providing you with prior
            notification or obtaining your consent.
            <br />
            <br />
            If you do not agree, either partially or wholly, to this Privacy
            Policy, you must immediately discontinue accessing, connecting,
            using, or engaging in our Services. This Privacy Policy does not
            apply to services offered by other companies or service providers or
            other websites linked from our Platform.
            <br />
            <br />
            If you still have any questions or concerns, please contact us at
            team@arkaine.io.
            <br />
            <br />
            SUMMARY OF KEY POINTS
            <br />
            <br />
            This summary provides key points from our privacy notice, but you
            can find out more details about any of these topics by using our
            table of contents below to find the section you are looking for.
            <br />
            <br />
            What personal information do we process? When you visit, use, or
            navigate our Services, we may process personal information depending
            on how you interact with MAITRIX LTD and the Services, the choices
            you make, and the products and features you use.
            <br />
            <br />
            Do we process any sensitive personal information? We do not process
            sensitive personal information.
            <br />
            <br />
            Do we receive any information from third parties? We do not receive
            any information from third parties.
            <br />
            <br />
            How do we process your information? We process your information to
            provide, improve, and administer our Services, communicate with you,
            for security and fraud prevention, and to comply with law. We may
            also process your information for other purposes with your consent.
            We process your information only when we have a valid legal reason
            to do so or requested by the regulator.
            <br />
            <br />
            In what situations and with which parties do we share personal
            information? We may share information in specific situations and
            with specific third parties such as regulators or if requested to do
            so legally.
            <br />
            <br />
            How do we keep your information safe? We have organizational and
            technical processes and procedures in place to protect your personal
            information. However, no electronic transmission over the internet
            or information storage technology can be guaranteed to be 100%
            secure, so we cannot promise or guarantee that hackers,
            cybercriminals, or other unauthorized third parties will not be able
            to defeat our security and improperly collect, access, steal, or
            modify your information.
            <br />
            <br />
            What are your rights? Depending on where you are located
            geographically, the applicable privacy law may mean you have certain
            rights regarding your personal information.
            <br />
            <br />
            How do you exercise your rights? The easiest way to exercise your
            rights is by contacting us. We will consider and act upon any
            request in accordance with applicable data protection laws.
            <br />
            <br />
            Want to learn more about what MAITRIX LTD does with any information
            we collect? <br />
            <br />
            TABLE OF CONTENTS <br />
            <br />
            1. WHAT INFORMATION DO WE COLLECT?
            <br />
            <br />
            2. HOW DO WE PROCESS YOUR INFORMATION?
            <br />
            <br />
            3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR PERSONAL
            INFORMATION?
            <br />
            <br />
            4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
            <br />
            <br />
            5. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?
            <br />
            <br />
            6. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            <br />
            <br />
            7. HOW LONG DO WE KEEP YOUR INFORMATION?
            <br />
            <br />
            8. HOW DO WE KEEP YOUR INFORMATION SAFE?
            <br />
            <br />
            9. DO WE COLLECT INFORMATION FROM MINORS?
            <br />
            <br />
            10. WHAT ARE YOUR PRIVACY RIGHTS?
            <br />
            <br />
            11. CONTROLS FOR DO-NOT-TRACK FEATURES
            <br />
            <br />
            12. DO WE MAKE UPDATES TO THIS NOTICE?
            <br />
            <br />
            13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
            <br />
            <br />
            14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
            YOU?
            <br />
            <br />
            1. WHAT INFORMATION DO WE COLLECT?
            <br />
            <br />
            Personal information you disclose to us. For the purposes of this
            Privacy Policy, Personal Information is information that can be used
            to identify, describe, relate, or associate with you as a particular
            individual.
            <br />
            <br />
            In Short: We collect personal information that you provide to us.
            <br />
            <br />
            We collect personal information that you voluntarily provide to us
            when you express an interest in obtaining information about us or
            our products and Services, when you participate in activities on the
            Services, or otherwise when you contact us.
            <br />
            <br />
            Personal Information Provided by You. The personal information that
            we collect depends on the context of your interactions with us and
            the Services, the choices you make, and the products and features
            you use. The personal information we collect may include the
            following:email addresses, full name, birthday date, nationality,
            home address, location, government identification number
            (Identification Card/Passport Number and Date of the Issuance of
            Identification Card/Passport), telegram username, digital wallet
            address, email address, IP address, documentation for proof of
            address and other information as we required which can be used to
            distinguish your identity, to access the Platform and for Know Your
            Customer (“KYC”) verification purposes. Sensitive Information (e.g.
            race, colour, political aspirations…) and Financial Information
            (e.g. detailed financial statements, wealth status…). We do not
            process sensitive or financial information.
            <br />
            <br />
            All personal information that you provide to us must be true,
            complete, and accurate, and you must notify us of any changes to
            such personal information.
            <br />
            <br />
            2. HOW DO WE PROCESS YOUR INFORMATION?
            <br />
            <br />
            In Short: We process your information to provide, improve, and
            administer our Services, communicate with you, for security and
            fraud prevention, and to comply with law. We may also process your
            information for other purposes with your consent.
            <br />
            <br />
            We process your personal information for a variety of reasons,
            depending on how you interact with our Services, including:
            <br />
            <br />
            To save or protect an individual’s vital interest. We may process
            your information when necessary to save or protect an individual’s
            vital interest, such as to prevent harm.
            <br />
            <br />
            3. WHAT LEGAL BASES DO WE RELY ON TO PROCESS YOUR INFORMATION?
            <br />
            <br />
            In Short: We only process your personal information when we believe
            it is necessary and we have a valid legal reason (i.e., legal basis,
            KYC purposes…) to do so under applicable law, like with your
            consent, to comply with laws, to provide you with services to enter
            into or fulfil our contractual obligations, to protect your rights,
            or to fulfil our legitimate business interests.
            <br />
            <br />
            If you are in the EU or UK, this section applies to you.
            <br />
            <br />
            The General Data Protection Regulation (GDPR) and UK (GDPR) and Data
            Protection Act (DPA) (as amended from time to time) require us to
            explain the valid legal bases we rely on to process your personal
            information. As such, we may rely on the following legal bases to
            process your personal information:
            <br />
            <br />
            Consent. We may process your information if you have given us
            permission (i.e., consent) to use your personal information for a
            specific purpose. You can withdraw your consent at any time. Learn
            more about withdrawing your consent by sending us an email to
            team@arkaine.io.Legal Obligations. We may process your information
            where we believe it is necessary for compliance with our legal
            obligations, such as to cooperate with a law enforcement body or
            regulatory agency, exercise or defend our legal rights, or disclose
            your information as evidence in litigation in which we are
            involved.Vital Interests. We may process your information where we
            believe it is necessary to protect your vital interests or the vital
            interests of a third party, such as situations involving potential
            threats to the safety of any person.If you are in Canada, this
            section applies to you.
            <br />
            <br />
            We may process your information if you have given us specific
            permission (i.e., express consent) to use your personal information
            for a specific purpose, or in situations where your permission can
            be inferred (i.e., implied consent). You can withdraw your consent
            at any time by sending us an email to team@arkaine.io.
            <br />
            <br />
            In some exceptional cases, we may be legally permitted under
            applicable law to process your information without your consent,
            including, for example:
            <br />
            <br />
            If collection is clearly in the interests of an individual and
            consent cannot be obtained in a timely way:For investigations and
            fraud detection and prevention;For business transactions provided
            certain conditions are met;If it is contained in a witness statement
            and the collection is necessary to assess, process, or settle an
            insurance claim;For identifying injured, ill, or deceased persons
            and communicating with next of kin;If we have reasonable grounds to
            believe an individual has been, is, or may be victim of financial
            abuse;If it is reasonable to expect collection and use with consent
            would compromise the availability or the accuracy of the information
            and the collection is reasonable for purposes related to
            investigating a breach of an agreement or a contravention of the
            laws of Canada or a provinceIf disclosure is required to comply with
            a subpoena, warrant, court order, or rules of the court relating to
            the production of recordsIf it was produced by an individual in the
            course of their employment, business, or profession and the
            collection is consistent with the purposes for which the information
            was producedIf the collection is solely for journalistic, artistic,
            or literary purposesIf the information is publicly available and is
            specified by the regulations
            <br />
            <br />
            4. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
            <br />
            <br />
            In Short: We may share information in specific situations described
            in this section and/or with the following third parties.
            <br />
            <br />
            We will not rent, sell, or disclose your Personal Information to any
            third parties, except to those who require access to the information
            to perform their tasks and duties under the binding agreements
            executed with us and to share with third parties who have a
            legitimate purpose for accessing it.We may share, transfer,
            disclose, or allow access to your Personal Information to the
            following third parties for the purposes described below:
            <br />
            <br />
            4.1 We may disclose Personal Information to the third parties in
            order to administer or process a transaction, or services you have
            authorized or requested, or in the context of facilitating the
            execution of a transaction, or we may disclose Personal Information
            to third parties that provide supporting services, or analytical
            information for the purpose of improving the Services, only where we
            have a lawful basis to do so or under an agreement or legal
            requirements for the transfer of Personal Information.
            <br />
            <br />
            4.2 We will be required to verify your identity by applicable laws
            and regulatory requirements and rely on third-party services to
            perform these verifications. Personal Information that you provide
            to us during the initial connecting process is passed to these
            services at KYC verification process and on an ongoing basis
            thereafter.
            <br />
            <br />
            4.3 We may disclose or transfer a part of your Personal Information
            if we are involved in a business transition or any merger and/or
            acquisition (M&A) projects. In such M&A event, your Personal
            Information might be among the assets transferred, but it will be
            protected and secure in accordance with this Privacy Policy.
            <br />
            <br />
            4.4. We may share your Personal Information with law enforcement,
            and government officials when we are compelled to do so by a
            subpoena, a valid court order to prevent financial loss, to report
            suspected illegal activity or to investigate violations of any of
            our Terms or any other applicable policies.
            <br />
            <br />
            4.5. We may share your Personal Information with third-party
            processors acting on behalf of Platform operator or engaged by
            Platform operator to process your Personal Information for Platform
            operator, our affiliate and/or our partners.
            <br />
            <br />
            All affiliate and third parties with whom we share your Personal
            Information have their own privacy policies. However, they will be
            expected to protect this information in a manner that aligns with
            the provisions described in this Privacy Policy.
            <br />
            <br />
            5. WHAT IS OUR STANCE ON THIRD-PARTY WEBSITES?
            <br />
            <br />
            In Short: We are not responsible for the safety of any information
            that you share with third parties that we may link to or who
            advertise on our Services, but are not affiliated with, our
            Services.
            <br />
            <br />
            The Services may link to third-party websites, online services, or
            mobile applications and/or contain advertisements from third parties
            that are not affiliated with us, and which may link to other
            websites, services, or applications. Accordingly, we do not make any
            guarantee regarding any such third parties, and we will not be
            liable for any loss or damage caused by the use of such third-party
            websites, services, or applications. The inclusion of a link towards
            a third-party website, service, or application does not imply an
            endorsement by us. We cannot guarantee the safety and privacy of
            data you provide to any third parties. Any data collected by third
            parties is not covered by this privacy notice. We are not
            responsible for the content or privacy and security practices and
            policies of any third parties, including other websites, services,
            or applications that may be linked to or from the Services. You
            should review the policies of such third parties and contact them
            directly to respond to your questions.
            <br />
            <br />
            6. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?
            <br />
            <br />
            In Short: We may use cookies and other tracking technologies to
            collect and store your information.
            <br />
            <br />
            We will use cookies and other technologies or methods of web and
            analytic tools to gather, store, and analyse certain information
            related with your access to and activities through the Services,
            including when you visit the Platform.A "cookie" is a small piece of
            information that a website assigns to your device while you are
            viewing a website. Cookies are beneficial and may be used for
            various purposes. These purposes include, among other things,
            allowing you to navigate between pages efficiently, enabling
            automatic activation of certain features, remembering your
            preferences and making the interaction between you and the Services
            quicker, easier and smoother. Our Platform will use the following
            types of cookies:
            <br />
            <br />
            8.1 Strictly Necessary CookiesThese cookies are essential to enable
            you to log in, navigate a website, and use its features or to
            provide a service requested by you. We will not need to obtain your
            consent in order to use these cookies.
            <br />
            <br />
            8.2 Functionality CookiesThese cookies allow the website to remember
            choices you make (such as your username, language, or the region you
            reside in) and provide enhanced, more personal features. The
            information these cookies collect remains anonymous, and they cannot
            track your browsing activity on other websites.
            <br />
            <br />
            8.3 Performance CookiesThese cookies collect information about how
            you use a website, for example, which pages you go to most often,
            how much time you spend on a page, record difficulties you may
            experience while using the website such as error messages. All
            information collected by these cookies is aggregated and therefore
            anonymous. It is only used to improve the efficiency of the website.
            <br />
            <br />
            8.4 Targeting Cookies or Advertising CookiesThese cookies are used
            to deliver advertisements tailored to you and your interests
            specifically. They are also used to limit the number of times you
            see an advertisement as well as help measure the effectiveness of
            the advertising campaign. These cookies remember that you have
            visited a website, and this information is shared with other
            organizations such as advertisers. Quite often targeting or
            advertising cookies will be linked to the sites’ functionality
            provided by the other organizations.You may remove these cookies by
            following the instructions of your device preferences. However, if
            you choose to disable cookies, some features of our Platform may not
            operate properly or become inaccessible, and your online experience
            may be limited. For further information please email us at
            team@arkaine.io.
            <br />
            <br />
            7. HOW LONG DO WE KEEP YOUR INFORMATION?
            <br />
            <br />
            In Short: We keep your information for as long as necessary to
            fulfil the purposes outlined in this privacy notice unless otherwise
            required by law.
            <br />
            <br />
            We will only keep your personal information for as long as it is
            necessary for the purposes set out in this privacy notice, unless a
            longer retention period is required or permitted by law (such as
            tax, accounting, or other legal requirements).
            <br />
            <br />
            When we have no ongoing legitimate business need to process your
            personal information, we will either delete or anonymize such
            information, or, if this is not possible (for example, because your
            personal information has been stored in backup archives), then we
            will securely store your personal information and isolate it from
            any further processing until deletion is possible.
            <br />
            <br />
            8. HOW DO WE KEEP YOUR INFORMATION SAFE?
            <br />
            <br />
            In Short: We aim to protect your personal information through a
            system of organizational and technical security measures.
            <br />
            <br />
            We have implemented appropriate and reasonable technical and
            organizational security measures designed to protect the security of
            any personal information we process. However, despite our safeguards
            and efforts to secure your information, no electronic transmission
            over the Internet or information storage technology can be
            guaranteed to be 100% secure, so we cannot promise or guarantee that
            hackers, cybercriminals, or other unauthorized third parties will
            not be able to defeat our security and improperly collect, access,
            steal, or modify your information. Although we will do our best to
            protect your personal information, transmission of personal
            information to and from our Services is at your own risk. You should
            only access the Services within a secure environment.
            <br />
            <br />
            9. DO WE COLLECT INFORMATION FROM MINORS?
            <br />
            <br />
            In Short: We do not knowingly collect data from or market to
            children under 18 years of age.
            <br />
            <br />
            We do not knowingly solicit data from or market to children under 18
            years of age. By using the Services, you represent that you are at
            least 18 or that you are the parent or guardian of such a minor and
            consent to such minor dependent’s use of the Services. If we learn
            that personal information from users less than 18 years of age has
            been collected, we will deactivate the account and take reasonable
            measures to promptly delete such data from our records. If you
            become aware of any data, we may have collected from children under
            age 18, please contact us at team@arkaine.io.
            <br />
            <br />
            10. WHAT ARE YOUR PRIVACY RIGHTS?
            <br />
            <br />
            In Short: In some regions, such as the European Economic Area (EEA),
            United Kingdom (UK), and Canada, you have rights that allow you
            greater access to and control over your personal information. <br />
            <br />
            You may review, change, or terminate your account at any time.
            <br />
            <br />
            In some regions (like the EEA, UK, and Canada), you have certain
            rights under applicable data protection laws. These may include the
            right (i) to request access and obtain a copy of your personal
            information, (ii) to request rectification or erasure; (iii) to
            restrict the processing of your personal information; and (iv) if
            applicable, to data portability. In certain circumstances, you may
            also have the right to object to the processing of your personal
            information. You can make such a request by contacting us by using
            the contact details provided in the section” HOW CAN YOU CONTACT US
            ABOUT THIS NOTICE? ” below.
            <br />
            <br />
            We will consider and act upon any request in accordance with
            applicable data protection laws.
            <br />
            <br />
            If you are in the EEA or UK and you believe we are unlawfully
            processing your personal information, you also have the right to
            complain to your Member State data protection authority or UK data
            protection authority.
            <br />
            <br />
            If you are in Switzerland, you may contact the Federal Data
            Protection and Information Commissioner.
            <br />
            <br />
            Withdrawing your consent: If we are relying on your consent to
            process your personal information, which may be express and/or
            implied consent depending on the applicable law, you have the right
            to withdraw your consent at any time. You can withdraw your consent
            at any time by contacting us by using the contact details provided
            in the section” HOW CAN YOU CONTACT US ABOUT THIS NOTICE? ” below .
            <br />
            <br />
            However, please note that this will not affect the lawfulness of the
            processing before its withdrawal nor, when applicable law allows,
            will it affect the processing of your personal information conducted
            in reliance on lawful processing grounds other than consent.
            <br />
            <br />
            Opting out of marketing and promotional communications: You can
            unsubscribe from our marketing and promotional communications at any
            time by clicking on the unsubscribe link in the emails that we send,
            or by contacting us using the details provided in the section” HOW
            CAN YOU CONTACT US ABOUT THIS NOTICE?” below. You will then be
            removed from the marketing lists. However, we may still communicate
            with you — for example, to send you service-related messages that
            are necessary for the administration and use of your account, to
            respond to service requests, or for other non-marketing purposes.
            <br />
            <br />
            Cookies and similar technologies: Most Web browsers are set to
            accept cookies by default. If you prefer, you can usually choose to
            set your browser to remove cookies and to reject cookies. If you
            choose to remove cookies or reject cookies, this could affect
            certain features or services of our Services.
            <br />
            <br />
            If you have questions or comments about your privacy rights, you may
            email us at team@arkaine.io.
            <br />
            <br />
            11. CONTROLS FOR DO-NOT-TRACK FEATURES
            <br />
            <br />
            Most web browsers and some mobile operating systems and mobile
            applications include a Do-Not-Track (“DNT”) feature or setting you
            can activate to signal your privacy preference not to have data
            about your online browsing activities monitored and collected. At
            this stage no uniform technology standard for recognizing and
            implementing DNT signals has been finalized. As such, we do not
            currently respond to DNT browser signals or any other mechanism that
            automatically communicates your choice not to be tracked online. If
            a standard for online tracking is adopted that we must follow in the
            future, we will inform you about that practice in a revised version
            of this privacy notice.
            <br />
            <br />
            12. DO WE MAKE UPDATES TO THIS NOTICE?
            <br />
            <br />
            In Short: Yes, we will update this notice as necessary to stay
            compliant with relevant laws.
            <br />
            <br />
            We may update this privacy notice from time to time. The updated
            version will be indicated by an updated “Revised” date and the
            updated version will be effective as soon as it is accessible. If we
            make material changes to this privacy notice, we may notify you
            either by prominently posting a notice of such changes or by
            directly sending you a notification. We encourage you to review this
            privacy notice frequently to be informed of how we are protecting
            your information.
            <br />
            <br />
            13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
            <br />
            <br />
            If you have questions or comments about this notice, you may email
            us at team@arkaine.io or contact us by post at: MAITRIX LTD 1st
            Floor, Irvine’s Place, 159 Main Street, P.O. Box 2132, Road Town,
            Tortola, British Virgin Islands
            <br />
            <br />
            14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM
            YOU?
            <br />
            <br />
            Based on the applicable laws of your country, you may have the right
            to request access to the personal information we collect from you,
            change that information, or delete it. To request to review, update,
            or delete your personal information, please reach out to
            team@arkaine.io.
          </p>
        </div>
      </div>
    </GradientBorderRadius>
  );
};

export default PrivacyPolicy;
